import React from 'react'

function Footer() {
  return (
    <footer className="bg-[#49352B] py-12">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 text-center space-y-4">
        <p className="font-display text-white text-xl font-bold">FORNO ESSENCIAL®</p>
        <div className="flex items-center justify-center gap-6 text-white/60 text-sm">
          <a href="#" className="hover:text-white transition-colors">Termos de Uso</a>
          <a href="#" className="hover:text-white transition-colors">Privacidade</a>
          <a href="#" className="hover:text-white transition-colors">Suporte</a>
        </div>
        <p className="text-white/40 text-xs">© 2024 Forno Essencial. Todos os direitos reservados.</p>
      </div>
    </footer>
  )
}

export default Footer
